// =============================================================================
// Frontend JavaScript - TypeScript Entry Point
// =============================================================================

import '../scss/frontend.scss';

// Lazy loading
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// import Vue from "vue";
// window.Vue = Vue;

import axios from 'axios';
window.axios = axios;

import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import Noty from 'noty';
window.Noty = Noty;

// Sections
import { NADMenuBar } from './sections/nad-menu-bar';
import { NADPromoBar } from './sections/nad-promo-bar';
import { NADPromoTopbar } from './sections/nad-promo-topbar';
import { NadHeroSection } from './sections/nad-hero-section';
import { NADHeroV2 } from './sections/nad-hero-v2';
import { NADBenefitsGrid } from './sections/nad-benefits-grid';
import { NADShopCardsV2 } from './sections/nad-shop-cards-v2';
import { NADLifestyleGallery } from './sections/nad-lifestyle-gallery';
import { NADComparisonTable } from './sections/nad-comparison-table';
import { NADTeamCredibility } from './sections/nad-team-credibility';
import { NADWhyDifferent } from './sections/nad-why-different';
import { NADOccasionBlock } from './sections/nad-occasion-block';
import { NADIngredientsV2 } from './sections/nad-ingredients-v2';
import { NADEnergySection } from './sections/nad-energy-section';
import { NADScienceSection } from './sections/nad-science-section';
import { NADProductShowcase } from './sections/nad-product-showcase';
import { NADResearch } from './sections/nad-research';
import { NADImageSlider } from './sections/nad-image-slider';
import { NADFooter } from './sections/nad-footer';
import { NADFaqsSection } from './sections/nad-faqs-section';
import { NADCollectionFilters } from './sections/nad-collection-filters';
import { NADCollectionList } from './sections/nad-collection-list';
import { NADCollectionProductGrid } from './sections/nad-collection-product-grid';
import { NADFormulaSection } from './sections/nad-formula-section';
import { NADBenefitsSection } from './sections/nad-benefits-section';
import { NADStimulantsSection } from './sections/nad-stimulants-section';
import './sections/nad-about-real-energy';
import { NADAboutNADPlus } from './sections/nad-about-nad-plus';
import { NadAboutHero } from './sections/nad-about-hero';
import { NADMainBlog } from './sections/nad-main-blog';
import { NADMainArticle } from './sections/nad-main-article';
import { NADStickyAddToCart } from './sections/nad-sticky-add-to-cart';
import { NADLimitedDropGuard } from './sections/nad-limited-drop-guard';
import { NADAiodUpcartFix } from './integrations/nad-aiod-upcart-fix';
import { NADIngredients } from './sections/nad-ingredients';
import { NADHowItWorks } from './sections/nad-how-it-works';
import { NADProductMobileHeader } from './sections/nad-product-mobile-header';
import { NADHandpickedReviews } from './sections/nad-handpicked-reviews';

// Snippets
import './snippets/nad-product-card.js';
import { NADCollectionSlider } from './snippets/nad-collection-slider';
import { NadProductGallery } from './snippets/nad-product-gallery';

// Templates
import { NADProductTemplate } from './templates/product';
import { NADAboutUsTemplate } from './templates/about-us';
import { NADHomeTemplate } from './templates/home';

// Components (TypeScript)
// import { createNadModal } from './components/NadModal';

// Install third-party integration fixes as early as possible (before AIOD inits).
NADAiodUpcartFix.init();

// Initialize components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize sections
  NADMenuBar.initializeAll();
  NADPromoBar.initializeAll();
  NADPromoTopbar.initializeAll();
  NadHeroSection.initializeAll();
  NADHeroV2.initializeAll?.();
  NADBenefitsGrid.initializeAll?.();
  NADShopCardsV2.initializeAll?.();
  NADLifestyleGallery.initializeAll?.();
  NADComparisonTable.initializeAll?.();
  NADTeamCredibility.initializeAll?.();
  NADWhyDifferent.initializeAll?.();
  NADOccasionBlock.initializeAll?.();
  NADIngredientsV2.initializeAll?.();
  NADEnergySection.initializeAll();
  NADScienceSection.initializeAll();
  NADProductShowcase.initializeAll();
  NADImageSlider.initializeAll();
  NADResearch.initializeAll();
  NADFaqsSection.initializeAll();
  NADFooter.initializeAll();
  NADCollectionFilters.initializeAll();
  NADCollectionList.initializeAll();
  NADCollectionProductGrid.initializeAll();
  NADFormulaSection.initializeAll();
  NADBenefitsSection.initializeAll();
  NADStimulantsSection.initializeAll();
  NADAboutNADPlus.initializeAll();
  NadAboutHero.initializeAll();
  NADMainBlog.initializeAll();
  NADMainArticle.initializeAll();
  NADStickyAddToCart.initializeAll();
  NADLimitedDropGuard.initializeAll();
  NADIngredients.initializeAll();
  NADHowItWorks.initializeAll();
  NADProductMobileHeader.initializeAll();
  NADHandpickedReviews.initializeAll();

  // Initialize snippets
  NADCollectionSlider.initializeAll();
  NadProductGallery.initializeAll();

  // Initialize templates
  NADProductTemplate.initializeAll();
  NADAboutUsTemplate.initializeAll();
  // NADHomeTemplate.initializeAll();
});
